import { FC, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations'
import { TKeyInitiative } from 'partner360/entities/keyInitiatives'
import { TRANSLATION_KEYS } from 'partner360/features/keyInitiatives/configs/translations'
import { getPlanField } from 'partner360/features/keyInitiatives/lib/financialFieldHelper'
import { TKeyInitiativesFinancialData } from 'partner360/features/keyInitiatives/model/financialData'
import { getGoalField } from 'partner360/features/keyInitiatives/ui/helpers/fieldHelper'
import { formatMoney } from 'partner360/features/keyInitiatives/ui/helpers/formatMoney'
import { getNumberValue } from 'partner360/features/keyInitiatives/ui/helpers/getNumberValue'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { KpiProgressBar } from '../common/kpiProgressBar/KpiProgressBar'
import { KpiTile } from '../common/kpiTile/KpiTile'

interface ITotalGoalProps {
  kiData: TKeyInitiative[]
  finData: TKeyInitiativesFinancialData[]

  activeCurrency: string
  actualsType: ActualsValueTypes
}

export const TotalGoal: FC<ITotalGoalProps> = ({
  kiData,
  finData,
  activeCurrency,
  actualsType,
}) => {
  const { totalGoal, target } = useMemo(() => {
    const goalField = getGoalField(actualsType, activeCurrency)
    const planField = getPlanField(actualsType, activeCurrency)

    const totalGoalValue = kiData.reduce((sum, item) => {
      const value = getNumberValue(item, goalField)

      return sum + value
    }, 0)

    const targetValue = getNumberValue(finData?.[0], planField)

    return {
      totalGoal: totalGoalValue,
      target: targetValue,
    }
  }, [kiData, finData, actualsType, activeCurrency])

  return (
    <KpiTile
      title={TRANSLATION_KEYS.dashboard.aggregatedView.totalGoal.title}
      value={formatMoney(totalGoal, activeCurrency)}
      footer={
        <KpiProgressBar
          label={
            <Translation
              text={TRANSLATION_KEYS.dashboard.aggregatedView.totalGoal.footer}
              replaceParams={[{ key: '{target}', value: formatMoney(target, activeCurrency) }]}
              span
            />
          }
          target={target}
          value={totalGoal}
        />
      }
    />
  )
}
